export const aiChatSceneEventName = 'ai-chat-scene-custom-event'

/**
 * What the AI chat wants the editor scene to show: a storey in the 2D
 * floorplan view (`show_storey`), an IFC model by its converted GLB file
 * (`show_ifc_model`, an IFC uploaded in the chat), or the planar elements a
 * hovered element link in an answer points at (`focusedElementGuids`, empty
 * again when the pointer leaves). The chat lives in the
 * navbar, outside the editor's context-scoped stores, so it publishes this
 * event and the editor of the same project applies it (`AIChatSceneBridge`).
 * An event nobody listens to (no editor open) is simply dropped.
 */
export type AIChatSceneEventData = { projectGuid: string } & (
  | { storey: string; glbFileGuid?: never; focusedElementGuids?: never }
  | { glbFileGuid: string; storey?: never; focusedElementGuids?: never }
  | { focusedElementGuids: string[]; storey?: never; glbFileGuid?: never }
)

export type AIChatSceneEvent = CustomEvent<AIChatSceneEventData>

function subscribeAIChatSceneEvent(handler: (event: AIChatSceneEvent) => void) {
  document.addEventListener(aiChatSceneEventName, handler as unknown as EventListener)
}

function unsubscribeAIChatSceneEvent(handler: (event: AIChatSceneEvent) => void) {
  document.removeEventListener(aiChatSceneEventName, handler as unknown as EventListener)
}

function publishAIChatSceneEvent(data: AIChatSceneEventData) {
  const event = new CustomEvent<AIChatSceneEventData>(aiChatSceneEventName, {
    detail: data,
  })
  document.dispatchEvent(event)
}

export { publishAIChatSceneEvent, subscribeAIChatSceneEvent, unsubscribeAIChatSceneEvent }
